<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="选择机构" prop="branchCode" style="margin-right:15px">
        <el-select v-model="form.branchCode" placeholder="请选择" @change="handleBranch">
          <el-option v-for="item in branchList" :key="item.code" :label="item.groupName" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="银行类型" prop="type" style="margin-right:15px">
        <el-select v-model="form.type" placeholder="请选择" clearable>
          <el-option v-for="item in BankTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="开户企业名称" prop="companyName" style="margin-right:15px">
        <el-input v-model="form.companyName" placeholder="请输入开户企业名称" readonly />
      </el-form-item>
      <el-form-item label="预留手机号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入预留手机号" />
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankNum" style="margin-right:15px">
        <el-input v-model="form.bankNum" placeholder="请输入银行卡号" />
      </el-form-item>
      <el-form-item label="开户银行" prop="bankCode" style="margin-right:15px">
        <el-select v-model="form.bankCode" placeholder="请选择" filterable @change="handleBank">
          <el-option v-for="item in bankList" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="开户行省份" prop="bankProvince" style="margin-right:15px">
        <el-select v-model="form.bankProvince" placeholder="请选择" filterable @change="getCityList">
          <el-option v-for="item in provinceList" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceName" />
        </el-select>
      </el-form-item>
      <el-form-item label="开户行城市" prop="bankCity" style="margin-right:15px">
        <el-select v-model="form.bankCity" placeholder="请选择" filterable>
          <el-option v-for="item in cityList" :key="item.cityCode" :label="item.cityName" :value="item.cityName" />
        </el-select>
      </el-form-item>
      <el-form-item label="联行号" prop="associateBankNumber" style="margin-right:15px">
        <el-input v-model="form.associateBankNumber" placeholder="请输入联行号" />
      </el-form-item>
      <el-form-item label="开户网点" prop="bankBranch" style="margin-right:15px">
        <el-input v-model="form.bankBranch" placeholder="请输入开户网点" />
      </el-form-item>
      <el-form-item label="是否默认" prop="isDefault" style="margin-right:15px">
        <el-switch v-model="form.isDefault" active-value="1" inactive-value="0" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { getListDict } from '@/api/commonApi'
import { validatePhone, isSpaceString } from '@/utils/validate.js'
import { isBankCardNum } from '@/utils/validate4Form'
export default {
  name: 'PlatformHouseholdAdd',
  data() {
    return {
      form: {
        code: '',
        type: '',
        isDefault: 0,
        bankBranch: '',
        associateBankNumber: '',
        bankCity: '',
        bankProvince: '',
        bankCode: '',
        bankName: '',
        bankNum: '',
        phone: '',
        companyName: '',
        branchCode: '',
        modifiedByName: ''
      },
      defaultOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],
      BankTypeOptions: [
        { label: '转账支付', value: 1 },
        { label: '银行支付', value: 0 }
      ],
      provinceList: [],
      cityList: [],
      bankList: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      rules: {
        isDefault: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ],
        associateBankNumber: [
          { required: true, message: '请输入银行联行号', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        bankCity: [
          { required: true, message: '请输入银行市', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        bankProvince: [
          { required: true, message: '请输入银行省', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        bankCode: [
          { required: true, message: '请选择银行', trigger: 'blur' },
          {
            required: true,
            validator(rule, value, callback) {
              isSpaceString(value)
                ? callback(new Error('格式有误'))
                : callback()
            }
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        bankNum: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' },
          { validator: isBankCardNum }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error('手机号格式有误'))
            }
          }
        ],
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        branchCode: [
          { required: true, message: '请输入机构编码', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ],
        modifiedByName: [
          { required: true, message: '请输入最后操作人', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符'
          }
        ]
      }
    }
  },
  created() {
    this.getProvinceList()
    this.selectDict()
  },
  methods: {
    init() {
      this.$refs['form'].resetFields()
    },
    //提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.form
          request({
            url: '/ntocc-basic-api/platformHousehold',
            method: 'post',
            params: data
          })
            .then((response) => {
              this.$message({ message: response.msg, type: 'success' })
              this.$emit('fatherAddMethod')
            })
            .then(() => this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    //取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    },
    // 选择分机构
    handleBranch(value) {
      const item = this.branchList.find((item1) => item1.code === value)
      this.form.companyName = item.groupName
    },
    handleBank(value) {
      const item = this.bankList.find((item1) => item1.code === value)
      this.form.bankName = item.name
    },
    // 获取省列表
    getProvinceList() {
      request({ url: '/ntocc-basic-api/areaProvince', method: 'get' }).then(
        (response) => {
          this.provinceList = response.data.records
        }
      )
    },
    // 获取市列表
    getCityList(value) {
      this.cityList = []
      this.form.bankCity = ''
      const item = this.provinceList.find(
        (item1) => item1.provinceName === value
      )
      request({
        url: '/ntocc-basic-api/areaCity',
        method: 'get',
        params: { provinceCode: item.provinceCode }
      }).then((response) => {
        this.cityList = response.data.records
      })
    },
    // 查询数据字典
    selectDict() {
      // 获取数据字典： 银行
      getListDict({ types: 'bank' }).then((response) => {
        this.bankList = response.data.filter((item) => item.type === 'bank')[0][
          'dictList'
        ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
